import { useCallback } from 'react';

import { useToastStore } from 'dibs-toaster/exports/useToastStore.ts';
import { ACTION_RESULT_TOAST_PROPS } from 'dibs-toaster/exports/sharedToastProps.ts';

import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext.tsx';
import {
    SaveSearchSuccessToastContent,
    RemoveFromSavedSearchesToastContent,
} from './SaveSearchSuccessToastContent.tsx';

type ToastOptions = { isSeller?: boolean };

export const useSaveSearchSuccessToast = (): {
    showSaveSearchSuccessToast: (options?: ToastOptions) => void;
    showRemoveSaveSearchToast: (options?: ToastOptions) => void;
} => {
    const addToast = useToastStore(state => state.add);
    const { isMobile } = useServerVarsContext();

    const showSaveSearchSuccessToast = useCallback(
        (options?: ToastOptions) => {
            addToast({
                toast: {
                    ...ACTION_RESULT_TOAST_PROPS,
                    children: (
                        <SaveSearchSuccessToastContent
                            isMobile={isMobile}
                            isSeller={options?.isSeller}
                        />
                    ),
                },
            });
        },
        [addToast, isMobile]
    );

    const showRemoveSaveSearchToast = useCallback(
        (options?: ToastOptions) => {
            addToast({
                toast: {
                    ...ACTION_RESULT_TOAST_PROPS,
                    children: <RemoveFromSavedSearchesToastContent isSeller={options?.isSeller} />,
                },
            });
        },
        [addToast]
    );

    return { showSaveSearchSuccessToast, showRemoveSaveSearchToast };
};
